"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require("Resources/mixins/colors");

exports.default = {
  computed: {
    inputTextColor: function inputTextColor() {
      return this.color ? this.color : _colors.DEFAULT_INPUT_TEXT_COLOR;
    },
    inputTextColorClass: function inputTextColorClass() {
      return "has-text-" + this.inputTextColor;
    },
    inputIconColor: function inputIconColor() {
      return this.iconColor ? this.iconColor : _colors.DEFAULT_INPUT_TEXT_COLOR;
    },
    inputIconColorClass: function inputIconColorClass() {
      return "has-text-" + this.inputIconColor;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/elements/mixins/input.js
// module id = n8aa
// module chunks = 0 1